<template>
	<div class="chart-marketing card">
		<loading
			:active="!loadingApi"
			:can-cancel="false"
			:is-full-page="false"
			color="#fba628"
			loader="dots"
			:width=64
			:height=64
		></loading>
		<div class="card-body">
			<div class="row mb-4">
				<div class="col-sm-5">
					<h4 class="card-title mb-1">Маркетинг (ЦКП)</h4>
					<div class="small text-muted">Период с {{ datePeriodStart}} по {{ datePeriodEnd}}</div>
				</div>
				<div class="col-sm-7 d-none d-md-block">
					<div class="btn-group btn-group-toggle float-right mr-3">
						<label class="btn btn-outline-primary" :class="period === -2 ? 'active' :''">
							<input type="radio" :value=-2  v-model="period">2 недели назад
						</label>
						<label class="btn btn-outline-primary" :class="period === -1 ? 'active' :''">
							<input type="radio" :value=-1  v-model="period">Предыдущая неделя
						</label>
						<label class="btn btn-outline-primary" :class="period === 0 ? 'active' :''">
						<input type="radio" :value=0 v-model="period">Текущая неделя
						</label>
					</div>
				</div>
			</div>
				<chart-bar v-if="loadingApi" :labels="labels" :datasets="datasets"></chart-bar>
		</div>
		<div v-if="loadingApi" class="card-footer">
			<div class="row text-center">
				<div v-for="(item, key) in labels" :key="key" class="col-sm-12 col-md mb-sm-2 mb-0">
					<div class="text-muted">{{ item }}</div>
					<strong>{{ datasets[0].data[key] | currency }}</strong>
					<div class="progress progress-xs mt-2">
						<div class="progress-bar" role="progressbar" style="width: 100%" :style="{backgroundColor: datasets[0].backgroundColor[key]}" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import moment from 'moment'
import Loading from 'vue-loading-overlay'
import api from '@/api/modules/payment/statistic/marketing'
import userApi from '@/api/modules/user/user'
import ChartBar from '@/components/charts/chart-bar'
import datePeriod from '@/libs/date/period'
export default {
	components: {
		Loading,
		ChartBar
	},
	data () {
		return {
			loadingApi: false,
			period: 0,
			datasets: [],
			labels: [],
			datePeriodStart: '',
			datePeriodEnd: ''
		}
	},
	created () {
		this.buildData()
	},
	methods: {
		buildData () {
			const _datePeriod = datePeriod.week(this.period)
			this.date = moment(_datePeriod[0]).format('YYYY-MM-DD')
			this.datePeriodStart = moment(_datePeriod[0]).format('DD.MM.YYYY')
			this.datePeriodEnd = moment(_datePeriod[1]).format('DD.MM.YYYY')
			const params = {
				date_start: this.date
			}
			let datasets = {
				label: '',
				data: [],
				backgroundColor: [],
				borderColor: [
					'rgba(255,99,132,1)',
					'rgba(54, 162, 235, 1)',
					'rgba(255, 206, 86, 1)',
					'rgba(75, 192, 192, 1)',
					'rgba(153, 102, 255, 1)',
					'rgba(255, 159, 64, 1)'
				],
				borderWidth: 1
			}
			this.loadingApi = false
			api.findAll(params).then((statistics) => {
				if (statistics === null) {
					this.loadingApi = true
					return false
				}
				statistics.forEach((value, key) => {
					userApi.findOne(value.user_id).then((user) => {
						// if (key > 1) return false
						this.labels[key] = user.first_name + ' ' + user.last_name
						datasets.data[key] = value.amount_sum
						if (key === statistics.length - 1) {
							datasets['backgroundColor'] = [
								'rgba(255, 99, 132, 0.2)',
								'rgba(54, 162, 235, 0.2)',
								'rgba(255, 206, 86, 0.2)',
								'rgba(75, 192, 192, 0.2)',
								'rgba(153, 102, 255, 0.2)'
							]
							this.datasets = []
							this.datasets.push(datasets)
							setTimeout(() => {
								this.loadingApi = true
							}, 500)
						}
					})
				})
			})
		}
	},
	watch: {
		period () {
			this.buildData()
		}
	}
}
</script>
<style lang="scss">
	.chart-marketing {
		.card-body {
			min-height: 300px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/payment/statistic/marketing.vue